export const SET_CURRENT_REVIEW = 'review/SET_CURRENT_REVIEW'

export const GET_REVIEW_ACTION = 'review/GET_REVIEW_ACTION'
export const GET_REVIEW_ACTION_DONE = 'review/GET_REVIEW_ACTION_DONE'
export const GET_REVIEW_ACTION_FAIL = 'review/GET_REVIEW_ACTION_FAIL'

export const REVIEW_ACTION = 'review/REVIEW_ACTION'
export const REVIEW_ACTION_DONE = 'review/REVIEW_ACTION_DONE'
export const REVIEW_ACTION_FAIL = 'review/REVIEW_ACTION_FAIL'